"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatISODate = exports.formatZonedDate = exports.getZonedStartOfDay = exports.getZonedEndOfDay = exports.getZonedEndOfMonth = exports.calculateZonedDate = exports.PACIFIC_TIME_ZONE = exports.parseDateString = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
/**
 *
 * @param input YYYY-MM-DD
 */
function parseDateString(input) {
    if (input.includes("T")) {
        return new Date(input);
    }
    // set time to noon to avoid timezone issues
    return new Date(`${input}T12:00:00.000Z`);
}
exports.parseDateString = parseDateString;
exports.PACIFIC_TIME_ZONE = "America/Los_Angeles";
function calculateZonedDate(date, tz, fn) {
    const inputZoned = (0, date_fns_tz_1.toZonedTime)(date, tz);
    const fnZoned = fn(inputZoned);
    return (0, date_fns_tz_1.fromZonedTime)(fnZoned, tz);
}
exports.calculateZonedDate = calculateZonedDate;
function getZonedEndOfMonth(date, timeZone) {
    return calculateZonedDate(date, timeZone, date_fns_1.endOfMonth);
}
exports.getZonedEndOfMonth = getZonedEndOfMonth;
function getZonedEndOfDay(date, timeZone) {
    return calculateZonedDate(date, timeZone, date_fns_1.endOfDay);
}
exports.getZonedEndOfDay = getZonedEndOfDay;
function getZonedStartOfDay(date, timeZone) {
    return calculateZonedDate(date, timeZone, date_fns_1.startOfDay);
}
exports.getZonedStartOfDay = getZonedStartOfDay;
function formatZonedDate(date, formatStr, timeZone) {
    const inputZoned = (0, date_fns_tz_1.toZonedTime)(date, timeZone);
    return (0, date_fns_1.format)(inputZoned, formatStr);
}
exports.formatZonedDate = formatZonedDate;
function formatISODate(date) {
    // handle timezone to keep date part the same ignoring time part
    const formatted = new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
    return (0, date_fns_1.format)(formatted, "yyyy-MM-dd");
}
exports.formatISODate = formatISODate;
//# sourceMappingURL=date-utils.js.map